export default {
  description: {
    type: 'string',
  },
  sharepointLink: {
    type: 'string',
    link: true,
    required: true,
  },
  projectType: {
    type: 'enum',
    required: true,
  },
  expectedProjectStart: {
    type: 'date',
    required: true,
    minDate: {
      when: {
        $isContractRenewal: {
          in: ['NO', null, undefined],
        },
      },
      value: '$TODAY',
      message: 'Please choose date in future',
    },
  },
  requiredResources: {
    type: 'array',
    required: true,
    forEach: {
      type: 'object',
      properties: {
        positionId: {
          type: 'enum',
          required: true,
        },
        technologyId: {
          type: 'enum',
          required: {
            value: true,
            when: {
              '$.positionId': {
                in: ['47', 47, 21, '21'],
              },
            },
          },
        },
        teamRole: {
          type: 'enum',
          required: true,
        },
        maxLevel: {
          type: 'string',
          required: true,
        },
        minLevel: {
          type: 'string',
          required: true,
        },
        noteText: {
          type: 'string',
          required: false,
        },
        qualification: {
          type: 'enum',
          required: false,
        },
        requiredFte: {
          type: 'int',
          minValue: 0,
          required: true,
        },
      },
    },
  },
};
